export default __webpack_public_path__ + "images/slideshow_close-4a6ddcd4466485ab7515e42b041f4da3.svg";